module.exports = __webpack_public_path__ + "img/iconguanli.4878e880.png";